var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { check, dlogger } from '@towns-protocol/dlog';
import { LoadPriority } from '../../../store/store';
import { PersistedObservable, persistedObservable } from '../../../observable/persistedObservable';
import { makeUserSettingsStreamId } from '../../../id';
import { isDefined } from '../../../check';
const logger = dlogger('csb:userSettings');
let UserSettings = class UserSettings extends PersistedObservable {
    riverConnection;
    constructor(id, store, riverConnection) {
        super({ id, streamId: makeUserSettingsStreamId(id), initialized: false }, store, LoadPriority.high);
        this.riverConnection = riverConnection;
    }
    onLoaded() {
        this.riverConnection.registerView(this.onClientStarted);
    }
    onClientStarted = (client) => {
        logger.log('onClientStarted');
        const streamView = client.stream(this.data.streamId)?.view;
        if (streamView) {
            this.initialize(streamView);
        }
        client.addListener('streamInitialized', this.onStreamInitialized);
        return () => {
            client.removeListener('streamInitialized', this.onStreamInitialized);
        };
    };
    onStreamInitialized = (streamId) => {
        if (streamId === this.data.streamId) {
            const streamView = this.riverConnection.client?.stream(this.data.streamId)?.view;
            check(isDefined(streamView), 'streamView is not defined');
            this.initialize(streamView);
        }
    };
    initialize = (_streamView) => {
        this.setData({ initialized: true });
    };
};
UserSettings = __decorate([
    persistedObservable({ tableName: 'userSettings' })
], UserSettings);
export { UserSettings };
//# sourceMappingURL=userSettings.js.map